import { lazy, Suspense } from "react";
import { RenderLoadingSpinnerInImageTag } from "./Helper";
import { useScrollToTop } from "../../Utility";

// * Components
// * import method different because its a lazy load import
const Home = lazy(() => import(`./Components/Account/Index`));
// import Home from "./Components/Account/Index";

export default function Account() {
  // * At the top of the page.
  useScrollToTop();

  return (
    <>
      <Suspense
        fallback={RenderLoadingSpinnerInImageTag(
          "w-20",
          "h-20",
          "Loading Account page please wait..."
        )}
      >
        <Home />
      </Suspense>
    </>
  );
}
